import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
// Modals
import { AlertasModales } from '../../../../helpers/alertasModales';
import { ActivatedRoute, Router } from '@angular/router';
// Servicios
import { ClientesService } from '../../../../services/Clientes.service';
import { PrestamosService } from '../../../../services/prestamos.service';
import { Helper } from '../../../../helpers/helper';
import { PadronService } from '../../../../services/padron.service';
import { EmpleadosServicio } from '../../../../services/empleado.service';
import { DatePipe, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-perfil-cliente',
  templateUrl: './perfil-cliente.component.html',
  styleUrls: ['./perfil-cliente.component.css']
})
export class PerfilClienteComponent {
  @ViewChild('pdf') pdf: ElementRef;
  datosCliente: any;
  cedulaCliente = '';
  Math: any;
  loaded = false;
  loading = false;
  verMovimientosPrestamo = false;
  prestamoMovimientos: any;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  markers = [];
  cargoMora = 0;
  moraPagada = 0;
  nombreDiferente = false;
  exportando = false;
  nombrePadron = '';
  apellidoPadron = '';
  omitirCambioNombrePadron = true;
  recibos = [];
  empleado: any;
  cobrador: string;
  configPdf: any;
  abono: number;
  atrasos: number;
  pendiente: number;
  pagado: number;
  mora: number;
  quickLoan = false;
  fotoCedula = 'assets/img/cedula.png';
  dirFotos = '';

  constructor(private modals: AlertasModales, private clienteService: ClientesService,
    private route: ActivatedRoute, private router: Router,
    public helper: Helper, private prestamosService: PrestamosService,
    private padron: PadronService, private render: Renderer,
    public empleadoService: EmpleadosServicio) {
      this.Math = Math;

    // Cargar datos del cliente por su id
    this.obtenerDatosCliente();
    this.initConfigPdf();
    this.empleado = this.empleadoService.datosEmpleado;
    
  }

  private setFotoCedula() {
    if (this.datosCliente.ultimo_prestamo) {
      if (this.datosCliente.ultimo_prestamo.foto_cliente) {

        this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${this.datosCliente.compania}/${this.datosCliente.cedula}/cedulas/${this.datosCliente.ultimo_prestamo.foto_cliente}`;

      }  else if (this.datosCliente.foto_perfil) {

        this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${this.datosCliente.compania}/${this.datosCliente.cedula}/cedulas/${this.datosCliente.foto_perfil}`;
        
      } else {
        
        this.fotoCedula = 'assets/img/cedula.png';
      }
    } else if (this.datosCliente.foto_perfil) {

      this.fotoCedula = `${this.helper.baseUrl}/uploads/clientes/${this.datosCliente.compania}/${this.datosCliente.cedula}/cedulas/${this.datosCliente.foto_perfil}`;
      
    } else {
      
      this.fotoCedula = 'assets/img/cedula.png';
    }
  }

  private obtenerDatosCliente(): void {
    this.route.params.subscribe(res => {
     this.clienteService.obtenerCliente(res.id).subscribe((data: any) => {
       if (data) {
         this.datosCliente = data;
         this.dirFotos = `${this.helper.baseUrl}/uploads/clientes/${this.datosCliente.compania}/${this.datosCliente.cedula}/archivos`;


          this.setFotoCedula();
         this.omitirCambioNombrePadron = data.omitir_cambio_nombre;
         this.padron.getCedula(data.cedula).subscribe((cedula: any) => {
          if (cedula) {
            if (String(data.nombre + ' ' + data.apellido) !== String(cedula.data.nombre + ' ' + cedula.data.apellidos)) {
              this.nombreDiferente = true;
              this.nombrePadron = cedula.data.nombre;
              this.apellidoPadron =  cedula.data.apellidos;
            }
          }
        });
         if (data.ultimo_prestamo) {
          this.cargoMora = data.ultimo_prestamo.cuotas.reduce( (a, b) => a + b.mora, 0);
          this.moraPagada = data.ultimo_prestamo.cuotas.reduce( (a, b) => a + b.mora_pagada, 0);
          this.abono = data.ultimo_prestamo.cuotas.filter(x => x.estado === 3).reduce((a, b) => a + b.total_pagado, 0);
          this.pagado = data.ultimo_prestamo.cuotas.filter(x => x.estado === 2).length;
          this.mora = data.ultimo_prestamo.cuotas.filter(x => x.estado !== 2 && x.mora > 0).length;
          this.atrasos = data.ultimo_prestamo.cuotas.filter(x => x.estado !== 2 && new Date(x.fecha_vence) < new Date()).length;
          this.pendiente = data.ultimo_prestamo.cuotas.filter(x => x.estado !== 2 && (x.monto_cuota + x.mora - x.total_pagado) > 0 ).length;
          const ultimo_pago = data.ultimo_prestamo.cuotas.filter(row => row.ultimo_pago !== null);
          this.cobrador = ultimo_pago.length > 0 ? ultimo_pago[ultimo_pago.length - 1].cobrador : 'Sin cobrador';

         }
        //  this.modals.descuentoCuotasNotaCredito(this.datosCliente);

         // tipo = 1: cliente, 2: notas, 3: pagos, 4: prestamos
         if (this.datosCliente.lat && this.datosCliente.lng) {
           this.markers.push({
            lat: this.datosCliente.lat,
            lng: this.datosCliente.lng,
            nombreCompleto: this.datosCliente.nombre + ' ' + this.datosCliente.apellido,
            foto_perfil: this.datosCliente.foto_perfil,
            tipo: 1,
            iconUrl: './assets/img/user-marker.png'
          });
         }

         for (const nota of this.datosCliente.comentarios) {
            if (nota.lat !== 0 && nota.lng !== 0) {
             this.markers.push({
               lat: nota.lat,
               lng: nota.lng,
               comentario: nota.comentario,
               empleado: nota.nombre_empleado,
               tipo: 2,
               iconUrl: './assets/img/comment-marker.png'
             });
           }
         }

         if (this.datosCliente.pagos) {
           for (const pago of this.datosCliente.pagos) {
             this.markers.push({
               lat: pago.lat,
               lng: pago.lng,
               empleado: pago.empleado,
               prestamo: pago.ID_PRESTAMO,
               numero_cuota: pago.numero_cuota,
               monto_pagado: pago.monto_pagado,
               monto_cuota: pago.monto_cuota,
               tipo: 3,
               iconUrl: './assets/img/dollar-marker.png'
             });
           }
        }

        for (const prestamo of this.datosCliente.prestamos) {
          if (prestamo.lat !== 0 && prestamo.lng !== 0) {
           this.markers.push({
             lat: prestamo.lat,
             lng: prestamo.lng,
             empleado: prestamo.empleado,
             prestamo: prestamo.ID_PRESTAMO,
             capital: prestamo.capital,
             monto_pagado: (this.datosCliente.pagos ? this.datosCliente.pagos.reduce( (a, b) => a + b.monto_pagado, 0) : 0),
             monto_cuotas: prestamo.monto_cuotas,
             ruta: prestamo.ruta,
             tipo: 4,
             iconUrl: './assets/img/loan-marker.png'
           });
         }
       }

        setTimeout(() => {

          this.loaded = true;
        }, 1);
       } else {
         this.router.navigate(['/404']);
       }
     });
    });
  }

  clienteEnMapa() {
    this.modals.vistaMapaNgbModal(this.markers, 'Vista del cliente en el mapa');
  }

  notaEnMapa(nota) {
    const markers = [
      {
        lat: nota.lat,
        lng: nota.lng,
        comentario: nota.comentario,
        empleado: nota.nombre_empleado,
        tipo: 2,
        iconUrl: '../../../../../assets/img/comment-marker.png'
      }
    ];
    this.modals.vistaMapaNgbModal(markers, 'Vista de nota en el mapa');
  }

  editarCliente() {
    this.router.navigate(['/editar/cliente', this.datosCliente.ID]);
  }

  registrarPrestamo() {
    localStorage.setItem('nuevoCliente', this.datosCliente.ID);
  }

  crearComentario() {
    this.modals.comentarioClienteNgbModal(this.datosCliente.ID)
    .then(res => {
      if (res) {
        this.datosCliente.comentarios.unshift(res);
      }
    });
  }

  obtenerMovimientoPrestamo() {}

  detalleRecibo(recibo) {
    this.modals.detalleReciboNgbModal(recibo);
  }

  detalleNotaCredito(notaCredito) {
    this.modals.detalleNotaCreditoNgbModal(notaCredito);
  }

  // Notas de credito a cuotas
  descuentoCuotasNotaCredito() {
    this.modals.descuentoCuotasNotaCredito(this.datosCliente).then(data => {
      this.obtenerDatosCliente();
    });
  }

  cartaPdf(): void {
    const datePipe = new DatePipe('en-US');
    const currencyPipe = new CurrencyPipe('en-US');
    const modeloCarta = {
      nombre:  {
        val: `${this.datosCliente.nombre} ${this.datosCliente.apellido}`,
        description: 'Atajo para insertar el nombre del cliente.'
      },
      cedula:  {
        val: this.datosCliente.cedula,
        description: 'Atajo para insertar la cedula/pasaporte del cliente.'
      },
      inicio: {
        val: datePipe.transform(this.datosCliente.ultimo_prestamo.fecha_inicio, 'dd-MM-yyyy'),
        description: 'Atajo para insertar la fecha que inició el préstamo.'
      },
      vencio: {
        val: datePipe.transform(this.datosCliente.ultimo_prestamo.fecha_finaliza, 'dd-MM-yyyy'),
        description: 'Atajo para insertar la fecha que vence el préstamo.'
      },
      ultimo_pago:  {
        val: datePipe.transform(this.datosCliente.ultimo_prestamo.fecha_ultimo_pago, 'dd-MM-yyyy') || 'nula',
        description: 'Atajo para insertar la fecha de último pago del préstamo.'
      },
      monto: {
        // tslint:disable-next-line:max-line-length
        val: currencyPipe.transform(this.datosCliente.ultimo_prestamo.atrasos - this.datosCliente.ultimo_prestamo.pagos_atrasos + this.cargoMora, 'RD$ ', 'symbol', '1.0-2'),
        description: 'Atajo para insertar el capital del préstamo.'
      },
      numeroPrestamo:  {
        val: this.datosCliente.ultimo_prestamo.ID_PRESTAMO,
        description: 'Atajo para insertar el Numero del préstamo.'
      },
      fechaPrestamo:  {
        val: datePipe.transform(this.datosCliente.ultimo_prestamo.fecha_prestamo, 'dd-MM-yyyy') || 'nula',
        description: 'Atajo para insertar la fecha del préstamo.'
      },
      estado: this.datosCliente.ultimo_prestamo.estado
    };
    this.modals.cartaPDFNgbModal(modeloCarta);
  }

  cartaSaldo(): void {
    this.modals.cartaSaldoNgbModal(this.datosCliente);
  }

  actualizarNombrePadronElectoral() {
    if (this.nombreDiferente) {

      const data = {
        nombre: this.nombrePadron,
        apellido: this.apellidoPadron,
        ID_CLIENTE: this.datosCliente.ID,
        ID_RUTA: this.datosCliente.ID_RUTA,
       };
       this.clienteService.actualizarNombrePadronElectoral(data).subscribe(res => {
         if (res) {
          this.nombreDiferente = false;
          this.datosCliente.nombre = this.nombrePadron;
          this.datosCliente.apellido = this.apellidoPadron;
          this.modals.correctoModalJquery('Operación realizada éxitosamente', 'green', 'modern', 'fa fa-gear');
         }
       });
    }
  }
  omitirCambioNombre() {
    const data = {
      ID_CLIENTE: this.datosCliente.ID
    };
    this.clienteService.omitirCambioNombrePadron(data).subscribe( resp => {
      if (resp) {
        this.omitirCambioNombrePadron = true;
      }
    });
  }

  imprimirEstadoCuenta() {
    if (!this.exportando && this.datosCliente.ultimo_prestamo) {

      this.exportando = true;
      setTimeout(() => {
        const datePipe = new DatePipe('en-US');
        const currencyPipe = new CurrencyPipe('en-US');
        const pdfTitulo = `Estado de cuenta de ${this.datosCliente.nombre} ${this.datosCliente.apellido}`;
        const columns = [
          {title: 'No.', dataKey: '0'},
          {title: 'Fecha Vence', dataKey: '1'},
          {title: 'Monto Cuotas', dataKey: '2'},
          {title: 'Fecha Pago', dataKey: '3'},
          {title: 'Recibo', dataKey: '4'},
          {title: 'Pagado', dataKey: '5'},
          {title: 'Cargos por Mora', dataKey: '6'},
          {title: 'Balance Cuenta', dataKey: '7'}
        ];
        const rows = [];
        const balanceTotal = this.datosCliente.ultimo_prestamo.cuotas
        .reduce( (a, b) => a + b.monto_cuota, 0);
        for (const row of this.datosCliente.ultimo_prestamo.cuotas) {
          rows.push({
            '0': row.numero_cuota,
            '1': datePipe.transform(row.fecha_vence, 'dd-MM-yyyy'),
            '2': currencyPipe.transform(row.monto_cuota),
            '3': datePipe.transform(row.ultimo_pago, 'dd-MM-yyyy') || '',
            '4': row.recibo || '',
            '5': currencyPipe.transform(row.total_pagado),
            '6': currencyPipe.transform( row.estado === 2 ? row.mora_pagada : row.mora),
            '7': currencyPipe.transform(balanceTotal - (row.numero_cuota * row.monto_cuota))
          });
        }
        const empleado = this.empleadoService.datosEmpleado.nombreCompleto;
        this.helper.exportarEstadoCuenta(
          this.configPdf,
          pdfTitulo,
          columns,
          rows,
          empleado,
          this.pdf,
          this.render).then(() => this.exportando = false).catch(() => this.exportando = false);
      }, 0);
    }
  }

  private initConfigPdf(): void {
    this.prestamosService.obtenerConfiguracionPrestamo()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.direccion
      };
    });
  }
  movimientosPrestamoClick() {
    this.verMovimientosPrestamo = !this.verMovimientosPrestamo;
    if (this.verMovimientosPrestamo) {
      this.InitMovimientosPrestamo();
    }
  }

  InitMovimientosPrestamo() {
    if (this.verMovimientosPrestamo && this.datosCliente.ultimo_prestamo.ID_PRESTAMO  !== 'undefined') {
      this.prestamosService.obtenerListaMovimientosPrestamos( this.datosCliente.ultimo_prestamo.ID_PRESTAMO, this.datosCliente.compania  ).subscribe(data => {
        if (data) {
          this.prestamoMovimientos = data;
        }
      });
    }
  }

  eliminarCliente() {
    // tslint:disable-next-line:max-line-length
    const msg = `Eliminar cliente <b>${this.datosCliente.nombre} ${this.datosCliente.apellido}</b>. Al realizar esta acción usted borrará toda la información relacionada con este cliente (Notas, Prestamos, Actividades, etc).`;
    this.modals.confirmModalJquery('¿Estas seguro?', msg, 'orange', 'material')
      .then(res => {
        if (res === 'SI') {
          this.modals.anularNgbModal('cliente', 'eliminar')
          .then(denegado => {
            if (denegado) {
              this.modals.timingNgbModal(10)
              .then(value => {
                if (value === 'OK') {
                  this.clienteService.eliminarCliente(this.datosCliente.ID, denegado)
                  .subscribe(() => {
                    this.modals.correctoModalJquery('Cliente eliminado con éxito', 'green', 'modern', 'fa fa-check');
                    this.router.navigate(['/inicio']);
                  }, err => {
                    if (err.status === 404) {
                      this.router.navigate(['/404']);
                    } else if (err.status == 403) {
                      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
                      'red',
                      'modern',
                      false,
                      'fa fa-file-text');
                    }
                  });
                }
              });
            }
          });
        }
      });
  }

  quickDetailLoan(cuenta, scroll) {
    this.quickLoan = true;
    this.loading = true;
    this.prestamosService.quickDetailLoan(cuenta.ID)
    .subscribe((res: any) => {
      if (res) {
        this.datosCliente.ultimo_prestamo = res;
        this.cargoMora = res.cuotas.reduce( (a, b) => a + b.mora, 0);
        this.setFotoCedula();
      }
      this.loading = false;
      setTimeout(() => {
        scroll.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'nearest'});
      }, 100);
    }, () => {
      this.loading = false;
      this.modals.validacionesModalJquery('Error al comunicarse con el servidor. Favor de verificar su conexión a internet', '',
      'orange',
      'modern',
      false,
      'fa fa-wifi');
    });
  }

  datePipe(fecha: string) {
    if (fecha === '0000-00-00 00:00:00') {
      return ''
    } else {
      return new DatePipe('en-US').transform(fecha, 'dd-MM-yyyy');
    }
  }

  verFotos() {
    this.modals.verFotosClienteNgbModal((this.datosCliente.archivos as any[]).map(row => row.path), this.datosCliente);
  }

  historialTelefonos() {
    const data = {
      cliente: `${this.datosCliente.nombre} ${this.datosCliente.apellido}`,
      ID: this.datosCliente.ID_CLIENTE
    };

    this.modals.historialTelefonosNgbModal(data);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/clientes/perfil/perfil-cliente/perfil-cliente.component.ts